import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { money, date, statusColor } from '../lib/format.js';

export default function Documents({ type }) {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [q, setQ] = useState('');
  const [status, setStatus] = useState('');
  const { data, isLoading } = useQuery({
    queryKey: ['documents', type, q, status],
    queryFn: () => api(`/api/documents?type=${type}${q ? `&q=${encodeURIComponent(q)}` : ''}${status ? `&status=${status}` : ''}`),
  });
  const title = { INVOICE: t('nav.invoices'), QUOTE: t('nav.quotes'), PROFORMA: t('nav.proformas'), CREDIT_NOTE: t('nav.creditNotes') }[type];
  return (
    <>
      <div className="page-header">
        <h1>{title}</h1>
        <div style={{ display: 'flex', gap: 8 }}>
          <select value={status} onChange={e => setStatus(e.target.value)}>
            <option value="">All statuses</option>
            {['DRAFT', 'SENT', 'PARTIALLY_PAID', 'PAID', 'OVERDUE', 'CANCELLED', 'VOIDED'].map(s => <option key={s}>{s}</option>)}
          </select>
          <input placeholder={t('common.search')} value={q} onChange={e => setQ(e.target.value)} />
          {type !== 'CREDIT_NOTE' && <Link className="btn btn-primary" to={`/documents/new?type=${type}`}>{t('common.new')}</Link>}
        </div>
      </div>
      {isLoading ? <div className="card">{t('common.loading')}</div> : (
        <table className="table">
          <thead>
            <tr>
              <th>Number</th><th>Date</th><th>Due</th><th>Client</th>
              <th style={{ textAlign: 'right' }}>Total</th>
              <th style={{ textAlign: 'right' }}>Paid</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data?.documents?.map(d => (
              <tr key={d.id} onClick={() => nav(`/documents/${d.id}`)} style={{ cursor: 'pointer' }}>
                <td><strong>{d.fullNumber}</strong></td>
                <td>{date(d.issueDate)}</td>
                <td>{date(d.dueDate)}</td>
                <td>{d.client?.name}</td>
                <td style={{ textAlign: 'right' }}>{money(d.total, d.currencyCode)}</td>
                <td style={{ textAlign: 'right' }}>{money(d.paidTotal, d.currencyCode)}</td>
                <td><span className="badge" style={{ background: statusColor(d.status), color: 'white' }}>{d.status}</span></td>
              </tr>
            ))}
            {!data?.documents?.length && <tr><td colSpan={7} className="empty">No documents.</td></tr>}
          </tbody>
        </table>
      )}
    </>
  );
}
